/* @flow */

// Ref: https://www.npmjs.com/package/babel-plugin-conditional-compilation
import typeof IdpManagerReal from './idpmanager';
import typeof IdpManagerStub from './idpmanager-stub';

let idp: IdpManagerReal | IdpManagerStub;
('#if ENABLE_IDP');
import idpReal from './idpmanager';
idp = idpReal;
('#else');
import idpStub from './idpmanager-stub';
idp = idpStub;
('#endif');
export default idp;
